// AppSupportPage.jsx  ->  /app/support
//
// Το App Store απαιτεί Support URL για κάθε εφαρμογή, και το Play Console
// απαιτεί email υποστήριξης. Αυτή η σελίδα καλύπτει και τα δύο.
//
// Δεν είναι διακοσμητική: ο reviewer την ανοίγει. Θέλει να δει ότι υπάρχει
// τρόπος επικοινωνίας και ότι απαντιούνται πραγματικές απορίες — γι' αυτό οι
// ερωτήσεις παρακάτω είναι αυτές που όντως προκύπτουν (εκτιμώμενες ημερομηνίες,
// γιατί δεν χρειάζεται λογαριασμός, τι γίνεται με τα ΕΠΑΛ), όχι γεμιστικό.

import { Link } from 'react-router-dom'
import LegalLayout from './LegalLayout'
import DocumentMeta from './DocumentMeta.jsx'

const CONTACT_EMAIL = 'giannisvrn@gmail.com'

const FAQ = [
  {
    q: 'Οι ημερομηνίες των εξετάσεων είναι σίγουρες;',
    a: 'Όχι, μέχρι να βγει το ΦΕΚ του Υπουργείου. Όσο είναι εκτίμηση, η εφαρμογή το γράφει καθαρά στην αρχική οθόνη. Μόλις ανακοινωθεί το επίσημο πρόγραμμα, οι ημερομηνίες ενημερώνονται αυτόματα — δεν χρειάζεται update από το store — και όποιος έχει ανοιχτές τις ειδοποιήσεις ειδοποιείται ότι άλλαξαν.',
  },
  {
    q: 'Δεν μου έρχονται ειδοποιήσεις.',
    a: 'Έλεγξε δύο πράγματα: ότι είναι ανοιχτές μέσα από Ρυθμίσεις της εφαρμογής, και ότι η εφαρμογή έχει άδεια για ειδοποιήσεις στις ρυθμίσεις του κινητού. Οι υπενθυμίσεις είναι τοπικές, οπότε δουλεύουν και χωρίς σύνδεση στο διαδίκτυο.',
  },
  {
    q: 'Γιατί δεν χρειάζεται λογαριασμός;',
    a: 'Επειδή δεν χρειάζεται. Ό,τι επιλέγεις μένει στο κινητό σου και δεν στέλνεται πουθενά. Το μειονέκτημα είναι ότι αν αλλάξεις συσκευή, ξαναδιαλέγεις πεδίο και σχολές.',
  },
  {
    q: 'Πώς υπολογίζονται τα μόρια;',
    a: 'Από τον μέσο όρο των τεσσάρων μαθημάτων του πεδίου σου, επί 1.000 — ίδια κλίμακα με τις βάσεις, ώστε να συγκρίνονται απευθείας. Είναι εκτίμηση: οι συντελεστές βαρύτητας ορίζονται από κάθε σχολή χωριστά, και οι σχολές με ειδικό μάθημα υπολογίζονται διαφορετικά.',
  },
  {
    q: 'Υποστηρίζεται το ΕΠΑΛ;',
    a: 'Όχι ακόμη. Το ΕΠΑΛ έχει δικούς του τομείς, δικό του πρόγραμμα εξετάσεων και δικές του βάσεις, οπότε δεν είναι απλή παραλλαγή του ΓΕΛ. Είναι στα σχέδια.',
  },
  {
    q: 'Βρήκα λάθος σε μια βάση ή σε μια ημερομηνία.',
    a: 'Στείλε το μας. Οι διορθώσεις στα δεδομένα φτάνουν σε όλους χωρίς update από το store, οπότε ένα σωστό μήνυμα διορθώνει την εφαρμογή για όλους μέσα στην ίδια μέρα.',
  },
]

export default function AppSupportPage() {
  return (
    <>
      <DocumentMeta
        title="Υποστήριξη Εφαρμογής | Panellele"
        description="Υποστήριξη για την εφαρμογή Panellele: συχνές ερωτήσεις για τις ειδοποιήσεις, τις ημερομηνίες των εξετάσεων και τον υπολογισμό μορίων, και τρόπος επικοινωνίας."
        canonical="https://www.panellhniesplus.gr/app/support"
      />

      <LegalLayout title="Υποστήριξη — Εφαρμογή Panellele">
        <p>
          Οτιδήποτε δεν δουλεύει, οτιδήποτε φαίνεται λάθος, ή οτιδήποτε λείπει:{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>. Απαντάμε σε όλα.
        </p>

        <p>
          Αν αναφέρεις πρόβλημα, βοηθάει πολύ να γράψεις <strong>ποιο κινητό</strong> έχεις και{' '}
          <strong>ποια έκδοση</strong> της εφαρμογής — τη βρίσκεις στο τέλος της οθόνης{' '}
          <strong>Ρυθμίσεις</strong>, στα Διαγνωστικά.
        </p>

        <h2>Συχνές ερωτήσεις</h2>
        <dl>
          {FAQ.map((item) => (
            <div key={item.q}>
              <dt>
                <strong>{item.q}</strong>
              </dt>
              <dd>{item.a}</dd>
            </div>
          ))}
        </dl>

        <h2>Απόρρητο</h2>
        <p>
          Η εφαρμογή δεν συλλέγει προσωπικά δεδομένα. Τα αναλυτικά είναι στην{' '}
          <Link to="/app/privacy">πολιτική απορρήτου της εφαρμογής</Link>.
        </p>

        <h2>Η εφαρμογή</h2>
        <p>
          <Link to="/app">Δες τι κάνει το Panellele</Link>, ή χρησιμοποίησε τα ίδια εργαλεία μέσα
          από τον ιστότοπο: <Link to="/vaseis">βάσεις</Link>,{' '}
          <Link to="/ypologismos-morion">υπολογισμός μορίων</Link> και{' '}
          <Link to="/programma">πρόγραμμα εξετάσεων</Link>.
        </p>
      </LegalLayout>
    </>
  )
}
